// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__izjpa","row":"ProcedureTreatmentSummary_row__lvP6T"};